module.exports = __webpack_public_path__ + "img/record.8315307.png";